export default "__VITE_ASSET__CdgCp9CU__"